"use strict";

const initializePromotionMessage = () => {
    const $promotionBannerContainer     = $(".js-head-message");
    const $promotionBannerDismissButton = $(".js-head-message-dismiss");
    const promotionBannerDismissed      = localStorage.getItem("promotionBannerDismissed");

    if (promotionBannerDismissed) {
        return;
    }

    $promotionBannerContainer.removeAttr("hidden");

    $promotionBannerDismissButton.on("click", () => {
        $promotionBannerContainer.attr("hidden", "true");
        localStorage.setItem("promotionBannerDismissed", true);
    });
};

export default initializePromotionMessage;
